<rask-action-button
    class="col-12"
    icon="fas fa-sync-alt"
    aid="masshantera"
    (click)="openMasshanteraDialog()"
    [disabled]="!masshanteraEnabled"
    >Masshantera arbetsorder
</rask-action-button>

<rask-action-button
    class="col-12"
    icon="fas fa-sync-alt"
    aid="uppdaterafranregelverk"
    (click)="uppdateraVirkesordrar()"
    [disabled]="!updateEnabled"
    >Uppdatera från regelverk
</rask-action-button>

<rask-action-button
    class="col-12"
    icon="fas fa-sync-alt"
    aid="uppdateradestineringsalternativ"
    (click)="updateDestineringsalternativ()"
    [disabled]="!updateEnabled"
    >Uppdatera destineringsalternativ
</rask-action-button>
